export const WAREHOUSE_SUPPLIER_DISCOUNT_GROUP = 'warehouse-supplier-discount-group';
